import { SxProps, Theme } from '@mui/material';
import { ZIndex } from '@/utils/zIndex';

export const modalRootSX: SxProps<Theme> = { zIndex: ZIndex.HIGHEST };

export const modalSX: SxProps<Theme> = { padding: 0 };

export const dialogContainerSX: SxProps<Theme> = {
	backgroundColor: 'white',
	position: 'absolute',
	overflow: 'auto',
	height: 'auto',
	top: { xs: 'auto', sm: '50%' },
	bottom: { xs: 0, sm: 'auto' },
	left: { xs: 0, sm: '50%' },
	right: { xs: 0, sm: 'auto' },
	transform: { xs: 'none', sm: 'translate(-50%, -50%)' },
	width: { xs: '100%', sm: 'auto' },
	maxWidth: { xs: '100%', sm: '661px' },
	maxHeight: { xs: '90dvh', sm: '90vh' },
	borderRadius: { xs: '12px 12px 0 0', sm: '6px' },
	padding: '50px 25px 25px 25px',
};

export const closeButtonSX: SxProps<Theme> = {
	position: 'absolute',
	right: '10px',
	top: '10px',
	'&:hover': {
		backgroundColor: 'transparent',
		color: 'inherit',
	},
};
